import FocusTrapper from './focus-trapper';

/* MOBILE MENU */
function handleMobMenu() {
    const menuBtn = document.querySelector('.js-toggle-menu');
    const menu = document.querySelector('.mob-menu');
    const header = document.querySelector('header');
    let menuOpen = false;

    mobMenuAccordions();

    menuBtn.addEventListener('click', () => {
        handleMenu();
    });

    function handleMenu() {
        if (menuBtn.classList.contains('btn-active')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    document.addEventListener('click', (e) => {
        if (!menuOpen) return;

        if (e.target.closest('a')) {
            closeMenu();
        }
    });

    function openMenu() {
        !menuBtn.classList.contains('btn-active') && menuBtn.classList.add('btn-active');
        !menu.classList.contains('menu-open') && menu.classList.add('menu-open');
        !header.classList.contains('mob-menu-open') && header.classList.add('mob-menu-open');

        document.body.classList.add('overflow-hidden');
        menuBtn.setAttribute('aria-expanded', true);
        menu.setAttribute('aria-hidden', false);
        menu.toggleAttribute('inert');

        const trapper = new FocusTrapper({
            el: header,
        });

        menuOpen = true;
    }

    function closeMenu() {
        menuBtn.classList.contains('btn-active') && menuBtn.classList.remove('btn-active');
        menu.classList.contains('menu-open') && menu.classList.remove('menu-open');
        header.classList.contains('mob-menu-open') && header.classList.remove('mob-menu-open');
        document.body.classList.remove('overflow-hidden');
        menuBtn.setAttribute('aria-expanded', false);
        menu.setAttribute('aria-hidden', true);
        menu.toggleAttribute('inert');
        menuOpen = false;
    }

    function mobMenuAccordions() {
        const accBtns = document.querySelectorAll('.mob-menu-accordion-btn');
        const accContents = document.querySelectorAll('.mob-menu-accordion-content');

        accContents.forEach((content) => {
            content.style.setProperty('--scrollheight', content.scrollHeight + 'px');
        });

        accBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                btn.closest('.mob-menu-accordion-btn-container').classList.toggle('active');
            });
        });
    }
}

export { handleMobMenu }